import { Component, Input, ViewChild } from "@angular/core";
import { IonPopover } from "@ionic/angular";

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent {
  @Input() path: string[];
  @Input() small = false;
  @ViewChild('popover') popover: IonPopover;

  seperator: string = " ⇒ ";

  constructor() {}

  async presentBreadcrumbPopover(event) {
    await this.popover.present(event);
  }
}
